export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_PROFILE_REQUEST = 'FETCH_USER_PROFILE_REQUEST';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const fetchUserProfileSuccess = (payload, isOnboarding) => ({
    type: FETCH_USER_SUCCESS,
    payload,
    isOnboarding
});
export const fetchUserProfile = (payload) => ({
    type: FETCH_USER_PROFILE_REQUEST,
    payload,
});
export const fetchUserFailure = (payload) => ({
    type: FETCH_USER_FAILURE,
    payload,
});
